import { createSyncStore } from '../factory';

export type TitleBarHistoryActionType = 'back' | 'forward' | 'reload';

export type TitleBarHistoryAction = {
  type: TitleBarHistoryActionType;
  requestId: number;
} | null;

export type TitleBarHistoryState = {
  canGoBack: boolean;
  canGoForward: boolean;
  pendingAction: TitleBarHistoryAction;
  nextRequestId: number;
};

export type TitleBarHistoryActions = {
  setNavigationState: (canGoBack: boolean, canGoForward: boolean) => void;
  requestBack: () => void;
  requestForward: () => void;
  requestReload: () => void;
  clearPendingAction: () => void;
};

const createPendingAction = (type: TitleBarHistoryActionType, requestId: number) => ({ type, requestId });

export const createTitleBarHistoryStore = (origin?: string) =>
  createSyncStore<TitleBarHistoryState, TitleBarHistoryActions>({
    channel: 'title-bar-history',
    syncKeys: ['canGoBack', 'canGoForward', 'pendingAction'],
    throttleMs: 0,
    state: {
      canGoBack: false,
      canGoForward: false,
      pendingAction: null,
      nextRequestId: 0,
    },
    actions: (set, get) => ({
      setNavigationState: (canGoBack, canGoForward) => set({ canGoBack, canGoForward }),
      requestBack: () => {
        const requestId = get().nextRequestId + 1;
        set({ nextRequestId: requestId, pendingAction: createPendingAction('back', requestId) });
      },
      requestForward: () => {
        const requestId = get().nextRequestId + 1;
        set({ nextRequestId: requestId, pendingAction: createPendingAction('forward', requestId) });
      },
      requestReload: () => {
        const requestId = get().nextRequestId + 1;
        set({ nextRequestId: requestId, pendingAction: createPendingAction('reload', requestId) });
      },
      clearPendingAction: () => set({ pendingAction: null }),
    }),
    syncOptions: origin ? { origin } : {},
  });
